import { extend } from 'flarum/common/extend';
/**
 * flarum/emoji's ":" suggestions only once a letter follows the colon.
 * Opened on the bare ":", they caught French typography's "mot :" - and
 * Enter then inserted an emoji instead of a new line (Jplm, Pomlo,
 * 2026-10). ":clin", ":champi"… still list them, as before.
 *
 * Its smiley button keeps opening the common ones: it works by typing that
 * same bare " :" (flarum/emoji's addComposerAutocomplete), so a click lets
 * the next one through. That button only exists here if flarum/emoji's
 * toolbarItems() ran first, hence flarum/emoji in composer.json's
 * optional-dependencies: booted before it (2026-10-28, extensions re-sorted
 * when champis-captions was enabled), this extension never marked the click,
 * and the smiley button closed its own list straight away.
 */
export default function openEmojiListAfterLetter() {
  extend('flarum/common/components/TextEditor', 'buildEditorParams', function (params) {
    params.inputListeners.push(() => {
      // After every listener of this input - flarum/emoji's, which opens
      // the list, included, whichever extension booted first.
      queueMicrotask(() => {
        const dropdown = this.emojiDropdown;
        const editor = this.attrs.composer.editor;
        const [start, end] = editor.getSelectionRange();

        // Anything typed after the button's ":" ends what the click allowed.
        // Not on its first input: fof/rich-text's editor reports one insert
        // more than once.
        if (editor.getLastNChars(1) !== ':') {
          this.champisEmojiButton = false;
          return;
        }
        if (!dropdown?.active || end > start || this.champisEmojiButton) return;

        // Closed and inactive, so Enter isn't taken for picking an emoji.
        dropdown.hide();
        dropdown.active = false;
      });
    });
  });
  extend('flarum/common/components/TextEditor', 'toolbarItems', function (items) {
    if (!items.has('emoji')) return;
    const button = items.get('emoji');
    const onclick = button.attrs.onclick;
    button.attrs.onclick = e => {
      this.champisEmojiButton = true;
      onclick?.(e);
    };
  });
}